import { render, staticRenderFns } from "./ATagWithExternalIcon.vue?vue&type=template&id=40ae0124&scoped=true"
import script from "./ATagWithExternalIcon.vue?vue&type=script&lang=js"
export * from "./ATagWithExternalIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ae0124",
  null
  
)

export default component.exports